$(document).ready(function() {   
 
function removeDisabled() {
  if($(document).find('.mw-apo-container-Found').length){}else{
      if($(document).find('.mw-apo-container').length){
        $('.mw-apo-container').addClass('mw-apo-container-Found');
        console.log('mw-apo-container-Found')
              $('.product-form__submit').removeAttr('disabled');
      }
  }
}
var interval = self.setInterval(function(){removeDisabled()},1000);
  
function details_menuopen() {
    if($(document).find('.hasdetails_menu').length){
      if( $('.hasdetails_menu').attr('open')){}
      else{
        $('.hasdetails_menu').attr('open','');
      }
    }
//     if($(document).find('.hasdetails_submenu').length){
//       if( $('.hasdetails_submenu').attr('open')){}
//       else{
//         $('.hasdetails_submenu').attr('open','');
//       }
//     }


////// swymGr Js Starts here  ////////
    if($(document).find('.textHaveChanged').length) {} else {
    
      if($(document).find('.mw-apo-container').length) {
    
          $(document).find('.mw-option:not(.not_remove_colon_string) span.mw-text').each(function() {
              var getTextString = $(this).text();
    
              var str1 = "Parent #2: ";
              if(getTextString.indexOf(str1) != -1) {
                var newTxt = $(this).text().replace(str1, '');
                  $(this).text(newTxt);
              }
              var str2 = "Parent #1: ";
                if(getTextString.indexOf(str2) != -1) {
                  var newTxt = $(this).text().replace(str2, '');
                  $(this).text(newTxt);
              }
              var str3 = "Child #1: ";
                if(getTextString.indexOf(str3) != -1) {
                  var newTxt = $(this).text().replace(str3, '');
                  $(this).text(newTxt);
              }
              var str4 = "Child #2: ";
                if(getTextString.indexOf(str4) != -1) {
                  var newTxt = $(this).text().replace(str4, '');
                  $(this).text(newTxt);
              }
              var str5 = "Child #3: ";
                if(getTextString.indexOf(str5) != -1) {
                  var newTxt = $(this).text().replace(str5, '');
                  $(this).text(newTxt);
              }
              var str6 = "Child #4: ";
                if(getTextString.indexOf(str6) != -1) {
                  var newTxt = $(this).text().replace(str6, '');
                  $(this).text(newTxt);
              }
              var str7 = "Child #5: ";
                if(getTextString.indexOf(str7) != -1) {
                  var newTxt = $(this).text().replace(str7, '');
                  $(this).text(newTxt);
              }
              var str8 = "1st: ";
                if(getTextString.indexOf(str8) != -1) {
                  var newTxt = $(this).text().replace(str8, '');
                  $(this).text(newTxt);
              }
              var str9 = "2nd: ";
                if(getTextString.indexOf(str9) != -1) {
                  var newTxt = $(this).text().replace(str9, '');
                  $(this).text(newTxt);
              }
          });
        
        $('.mw-apo-container').addClass('textHaveChanged');
        
      }
    
    }
////// swymGr Js ends here  ////////

  
  }
  var interval = self.setInterval(function(){details_menuopen()},80);

 

//      $(".hasdetails_menu").hover(function(){
//       $(this).attr('open', 'open');
//       },
//      function(){
//       $(this).removeAttr('open');
//     });
    $('.image-with-tabs-button').click(function(){
      var tab_id = $(this).attr('data-tab');
      $('.image-with-tabs-button').removeClass('active');
      $('.image-with-tabs-content').removeClass('active');
      $(this).addClass('active');
      $("#"+tab_id).addClass('active');
    });
    
 $('div#ctt_slide-carousel').owlCarousel({
    loop:true,
    margin:20,
    dots: true,
    nav:false,
    autoplay: true,
    slideSpeed : 2000,
	autoplaySpeed:2000,
    responsiveClass:true,
    responsive:{
        0:{
            items:1
        },
        750:{
            items:1
        }
    }
});
    $('.image-with-text-slider').owlCarousel({
    loop:true,
    margin:20,
    dots: false,
    nav:true,
    autoplay: true,
    slideSpeed : 2000,
	autoplaySpeed:2000,
    responsiveClass:true,
    responsive:{
        0:{
            items:1
        },
        750:{
            items:2
        }
    }
});
    $('.kite_cover').on('click', function () {
      $(this).children().css({
        'z-index' : 1,
        'opacity': 1
      });
      $(this).children('.play_icon').css({
        'z-index' : -1,
        'opacity': 0
      });
      $(this).children().trigger('play');
    }); 
    
    $('.faqs-tabs-button').click(function(){
      var tab_id = $(this).attr('data-tab');
      $('.faqs-tabs-button').removeClass('active');
      $('.faqs-tabs-content').removeClass('active');
      $(this).addClass('active');
      $("#"+tab_id).addClass('active');
    }); 

  
      setTimeout(function () {
        var result = 0;
        var option_id = 0; 
        var result_total = 0;
        var cccresult_total = 0;
        $('.mw-option--type-checkbox').each(function() {
          var checkbox_id = $(this).attr('id'); 
          $('#'+checkbox_id+' .mw-option__value').each(function() {
            var check_ke_papa = $(this); 
          check_ke_papa.find('label.mw-label input[type=checkbox].mw-option__control').on('click', function () {
            option_id = $('.product-form .price .price__regular').find('span.price-item').text().replace("$", "").replace('USD','');
            option_id = parseFloat(option_id.replace("$", ""));
            // alert(option_id);  
            // alert(check_ke_papa);
            if (check_ke_papa.find('label.mw-label input[type=checkbox]:checked.mw-option__control').is(':checked')) { 
             var check_price = check_ke_papa.find('label.mw-label').find('.mw-option__value-title span.mw-text.mw-option__price').text();
              check_price = parseFloat(check_price.replace("(+$", ""));
               cccresult_total = check_price + option_id;
              // result += check_price;
//               result_total = result + option_id;
               // alert(cccresult_total + option_id); 
              // alert(cccresult_total);
              $('.product-form .price .price__regular').find('span.price-item').text('$'+cccresult_total+'USD');
              // alert(result); 
            } 
            else {
             var check_price = check_ke_papa.find('label.mw-label').find('.mw-option__value-title span.mw-text.mw-option__price').text();
              check_price = parseFloat(check_price.replace("(+$", ""));
               cccresult_total = option_id - check_price;
//               result -= check_price;
//               result_total = option_id - result;
               // alert(cccresult_total); 
            $('.product-form .price .price__regular').find('span.price-item').text('$'+cccresult_total+'USD');      
            }
          });
          });
          
//           var selectedSelect = '-- Please Select --';
//          var selectedOption = 0;
//         $('#'+checkbox_id+' select.mw-option__control').change(function(){        
//           var selectedOption = $(this).children("option:selected").text();
// // s          if (selectedSelect == selectedOption) {
// //           alert("You have =" + selectedOption);
// //         }
//             selectedOption = selectedOption.split("$");
//             selectedOption = selectedOption[1];
          
//             selectedOption = selectedOption.split(".");
//             var lastselectedOption = parseFloat(selectedOption[0]);
//           $('.product-form .price .price__regular').find('span.price-item').text('$'+lastselectedOption+'USD');
// //           alert("You have =" + lastselectedOption);
//         });
          
        });
      }, 3000);



  });


$(window).on('load', function() { 
  $('#status').fadeOut(); 
  $('#preloader').delay(350).fadeOut('slow'); 
//   $('body').delay(350).css({'overflow':'visible'});
})